import MessagesList from "@/components/lists/messages-list.vue"
export default {
    components : {
        MessagesList,
    }
}
